import React, { useEffect, useState } from 'react';

function Standings({ seasonId, selectedTeamId }) {
  const [standings, setStandings] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!seasonId) return;
    fetch(`/api/standings?season_id=${seasonId}`)
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) {
          setStandings(data);
          setError(null);
        } else if (data && data.error) {
          setError(data.error);
          setStandings([]);
        }
      })
      .catch(e => setError('Chyba při načítání tabulky.'));
  }, [seasonId]);

  if (error) return <div style={{color:'red'}}>{error}</div>;
  if (!standings || !Array.isArray(standings)) return null;
  if (standings.length === 0) return <div>V této sezóně zatím nejsou žádné týmy ani zápasy.</div>;

  return (
    <div>
      <h2 className="text-center mb-4">Tabulka</h2>
      <div className="table-responsive">
        <table className="table table-striped table-hover align-middle bg-white">
          <thead className="table-light">
            <tr>
              <th className="text-center">#</th>
              <th>Tým</th>
              <th className="text-center">Z</th>
              {/* Skryto na mobilech */}
              <th className="text-center d-none d-md-table-cell">V</th>
              <th className="text-center d-none d-md-table-cell">R</th>
              <th className="text-center d-none d-md-table-cell">P</th>
              <th className="text-center">Skóre</th>
              <th className="text-center">Body</th>
            </tr>
          </thead>
          <tbody>
            {standings.map((team, i) => (
              <tr key={team.id} className={selectedTeamId && team.id === selectedTeamId ? 'table-info fw-bold' : ''}>
                <td className="text-center">{i + 1}</td>
                <td>{team.name}</td>
                <td className="text-center">{team.played}</td>
                 {/* Skryto na mobilech */}
                <td className="text-center d-none d-md-table-cell">{team.won}</td>
                <td className="text-center d-none d-md-table-cell">{team.draw}</td>
                <td className="text-center d-none d-md-table-cell">{team.lost}</td>
                <td className="text-center">{team.gf}:{team.ga}</td>
                <td className="text-center fw-bold">{team.points}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Standings;
